// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    // const dataMenu = ['dashboard', 'menu'];
    const navItems = menuItem.items.map((item) => {
        switch (item.type) {
            case 'group':
                // console.log(dataMenu.indexOf(item.id) > -1);
                // return dataMenu.indexOf(item.id) > -1 ? <NavGroup key={item.id} item={item} /> : null;
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
